package amazon.lastmile.inject

import app.nestbridge.feature.main.presentation.MainShellPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = MainShellPresenterFactory::class)
public interface AppNestbridgeFeatureMainPresentationMainShellPresenterFactory {
  @Provides
  @IntoSet
  public fun provideMainShellPresenterFactoryFactoryMultibinding(mainShellPresenterFactory: MainShellPresenterFactory): Presenter.Factory = mainShellPresenterFactory
}
